// Wallet Manager doesn't track interactions or myWallet

var defaultPaymentsInfo = {
  creditAppDeals: [],
  creditType: 'b',
  // isLoading: false,
  // isPaymentsInfoLoaded: false,
  leaseMileageRange: 12000,
  leaseTerm: 36,
  loanTerm: 60,
  dealDetails: {},
  dealNotifications: {},
  downPayment: null,
  downPaymentPercent: 0.2,
  budget: null,
  dealType: null,
  interestRate: {
    isFallback: true,
    custom: null,
    new: 6.0,
    used: 7.05
  },
  tradeIn: {
    value: null,
    amountOwed: null,
    condition: null,
    source: null,
    ico: []
  },
  monthlyBudget: null,
  icoTradeIn: {},
  lastUpdated: null,
  createdDate: null,
  hasPreviousPaymentInfo: false,
  interactions: {
    //     disablePaymentPopover: false,
    //     disableComparePopover: false,
    //     useFallbackLead: false,
    //     hasOpenedTradeIn: false,
    //     hasUpdatedCreditOrTerm: false,
    //     hasUpdatedNDSCalc: false,
    //     hasUpdatedWallet: false,
    //     hasRequestedTaxesFees: false,
    //     hasBudgetInteraction: false,
    //     paymentEmphasis: false,
    //     hideReceipt: [],
  },
  penciling: {
    customLender: {},
    offerPrice: null,
    icoTradeInOffer: null,
    pencilingPayments: {}
  },
  myWallet: {
    // paymentOption: 'finance',
    // displayModal: false,
    // hideBackButton: false,
    // listingId: null,
    // listingCategory: null,
    // selectedPanelName: null,
    // showPaymentDetailsModal: false,
    // showPencilingPayments: false,
    // displayWalletErrorMessage: false,
    configs: {},
    // WALLET MANAGER TODO: Do we need this?
    displayConfigs: {}
  },
  creditVerification: {
    verified: false,
    verifiedDate: null
  },
  listingPayments: {},
  listingIncentives: {},
  listingLeasePayments: {},
  listingCashPayments: {},
  zip: null,
  tenant: null,
  timeStamp: null,
  previousPaymentInfo: {},
  walletId: null,
  hasSessionWalletChange: false
};
export { defaultPaymentsInfo as default };
